export const CHANGE_MENU = 'menu/CHANGE_MENU';
export const CHANGE_SELECTED = 'menu/CHANGE_SELECTED';